module.exports = __webpack_public_path__ + "static/img/policy-footer.5e3e14c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/policy-footer.png
// module id = moCI
// module chunks = 0